export const INIT_CUSTOMERS_FETCH = 'INIT_CUSTOMERS_FETCH';
export const INIT_PROFILE_UPDATE = 'INIT_PROFILE_UPDATE';

export const SIGNED_IN = 'SIGNED_IN';
export const SIGNED_OUT = 'SIGNED_OUT';
